import { useIsOrgManager } from '@/hooks/usePermissions';
import { isObjectIdHex } from '@/lib/utils';

export interface EditorSuggestionSource {
  /** The draft node a suggestion raised here anchors to (`stableStepId`). */
  anchorId?: string;
  /** Whether the user may skip the suggestion and create the entity outright. */
  allowCreate: boolean;
}

/**
 * The suggest-vs-create decision every draft-editor picker host shares.
 *
 * An optimistic node still carries a client-minted `temp-draft-step-…` id,
 * which the anchor endpoints would reject — no anchor is emitted until the
 * node reconciles, which leaves the picker's suggest affordance hidden
 * meanwhile.
 */
export function useEditorSuggestionSource(nodeId: string | undefined): EditorSuggestionSource {
  return {
    anchorId: nodeId && isObjectIdHex(nodeId) ? nodeId : undefined,
    allowCreate: useIsOrgManager()
  };
}
